import { render, staticRenderFns } from "./WeCare.vue?vue&type=template&id=76063590&lang=pug"
import script from "./WeCare.vue?vue&type=script&lang=js"
export * from "./WeCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports